import { Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ContainerComponent } from '../../components/container/container.component';
import { HeaderComponent } from '../../components/header/header.component';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { map, switchMap, tap } from 'rxjs';
import { selectCategoryBySlug, selectProductsByCategory } from '../../store/webshop/webshop.selectors';
import { EnrichedCategory, EnrichedProduct } from '../../store/webshop/webshop.models';
import { GalleryComponent } from '../../components/gallery/gallery.component';
import { ProductCardComponent } from '../../components/product-card/product-card.component';
import { Item } from '../../components/gallery/gallery.models';
import { Meta, Title } from '@angular/platform-browser';
import { selectSearchTerm } from '../../store/webshop/webshop.reducer';

@Component({
  selector: 'app-products-overview',
  standalone: true,
  imports: [
    ContainerComponent,
    HeaderComponent,
    GalleryComponent,
    ProductCardComponent
  ],
  templateUrl: './products-overview.component.html',
  styleUrl: './products-overview.component.scss'
})
export class ProductsOverviewComponent implements OnInit {
  category = signal<EnrichedCategory | undefined>(undefined);
  products = signal<EnrichedProduct[]>([]);

  private route = inject(ActivatedRoute);
  private store = inject(Store);
  private destroyRef = inject(DestroyRef);
  private document = inject(DOCUMENT);
  private titleService = inject(Title);
  private metaService = inject(Meta);

  searchTerm = toSignal(this.store.select(selectSearchTerm), { initialValue: '' });

  filteredProducts = computed(() => {
    const term = this.searchTerm().toLowerCase();
    if (!term) return this.products();

    return this.products().filter(product => {
      return product.enrichedAttributes.some((attr) =>
        attr.displayValue.toLowerCase().includes(term)
      );
    });
  });

  images = signal<Item[] | undefined>(undefined);

  scrollToTop() {
    this.document.defaultView?.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  ngOnInit() {
    this.route.params.pipe(
      map(params => params['slug']),
      switchMap(slug => this.store.select(selectCategoryBySlug(slug))),
      tap(category => this.category.set(category)),
      switchMap(category => this.store.select(selectProductsByCategory(category?.id))),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(products => {
      this.products.set(products);
      const category = this.category();
      if (category) {
        this.titleService.setTitle(category.name);
      } else {
        this.titleService.setTitle('Producten');
      }
    });

    this.images.set([
      {
        itemImageSrc: 'home/index1.jpg',
        alt: 'Description for Image 1',
        title: 'Title 1'
      },
      {
        itemImageSrc: 'home/index3.jpg',
        alt: 'Description for Image 1',
        title: 'Title 1'
      },
      {
        itemImageSrc: 'home/index4.jpg',
        alt: 'Description for Image 1',
        title: 'Title 1'
      }
    ]);
  }
}
